export default __webpack_public_path__ + "a6dac47.png";